import { useFlags } from "flagsmith/react";
import { useUser } from "./useUser";

interface AdvancedRecAccess {
	isAdvancedRecDisabled: boolean;
	isAdvancedRecEnabled: boolean;
}

export function useAdvancedRecAccess(): AdvancedRecAccess {
	const flags = useFlags(["disable_advanced_rec"]);
	const { user } = useUser();

	const flag = flags?.disable_advanced_rec;

	// If flag doesn't exist or is not enabled globally, advanced rec is enabled
	if (!flag || !flag.enabled) {
		return {
			isAdvancedRecDisabled: false,
			isAdvancedRecEnabled: true,
		};
	}

	// If flag is enabled globally but no user-specific list, disable for all
	if (!flag.value || !user?.id) {
		return {
			isAdvancedRecDisabled: true,
			isAdvancedRecEnabled: false,
		};
	}

	// Parse comma-separated list of user IDs from flag value (users who CAN access)
	const enabledUserIds = String(flag.value)
		.split(",")
		.map((id) => id.trim())
		.filter((id) => id !== "")
		.map((id) => parseInt(id, 10))
		.filter((id) => !isNaN(id));

	// Check if current user is in the enabled list
	const isUserEnabled = enabledUserIds.includes(user.id);

	return {
		isAdvancedRecDisabled: !isUserEnabled,
		isAdvancedRecEnabled: isUserEnabled,
	};
}
